import { ThemeColorPaletteSlots, ThemeFontsCssPropertyName } from '@fluidx/office-fluid-types';
import { AppStylingProvider } from '@fluidx/utilities';
import { getIsDarkTheme } from 'owa-fabric-theme';
import { getPaletteAsRawColors } from 'owa-theme';

let appStylingProvider;

export function getAppStylingProvider(): AppStylingProvider {
    if (appStylingProvider) {
        return appStylingProvider;
    }
    appStylingProvider = new AppStylingProvider();
    setThemeOnProvider();
    return appStylingProvider;
}

export function setThemeOnProvider() {
    const propertyArray: [string, string][] = [];

    const palette = getPaletteAsRawColors();

    propertyArray.push(
        [ThemeColorPaletteSlots.themePrimary, palette.themePrimary],
        [ThemeColorPaletteSlots.themeLighterAlt, palette.themeLighterAlt],
        [ThemeColorPaletteSlots.themeLighter, palette.themeLighter],
        [ThemeColorPaletteSlots.themeLight, palette.themeLight],
        [ThemeColorPaletteSlots.themeTertiary, palette.themeTertiary],
        [ThemeColorPaletteSlots.themeSecondary, palette.themeSecondary],
        [ThemeColorPaletteSlots.themeDarkAlt, palette.themeDarkAlt],
        [ThemeColorPaletteSlots.themeDark, palette.themeDark],
        [ThemeColorPaletteSlots.themeDarker, palette.themeDarker],
        [ThemeColorPaletteSlots.neutralLighterAlt, palette.neutralLighterAlt],
        [ThemeColorPaletteSlots.neutralLighter, palette.neutralLighter],
        [ThemeColorPaletteSlots.neutralLight, palette.neutralLight],
        [ThemeColorPaletteSlots.neutralQuaternaryAlt, palette.neutralQuaternaryAlt],
        [ThemeColorPaletteSlots.neutralQuaternary, palette.neutralQuaternary],
        [ThemeColorPaletteSlots.neutralTertiaryAlt, palette.neutralTertiaryAlt],
        [ThemeColorPaletteSlots.neutralTertiary, palette.neutralTertiary],
        [ThemeColorPaletteSlots.neutralSecondary, palette.neutralSecondary],
        [ThemeColorPaletteSlots.neutralPrimaryAlt, palette.neutralPrimaryAlt],
        [ThemeColorPaletteSlots.neutralPrimary, palette.neutralPrimary],
        [ThemeColorPaletteSlots.neutralDark, palette.neutralDark],
        [ThemeColorPaletteSlots.black, palette.black],
        [ThemeColorPaletteSlots.white, palette.white],
        [ThemeFontsCssPropertyName.FontSizeHeading1, '14px'],
        [ThemeFontsCssPropertyName.FontFamilyHeading1, 'Segoe UI']
    );

    if (getIsDarkTheme()) {
        propertyArray.push(
            [ThemeColorPaletteSlots.EntityRecognitionUnderline, '#8a8886'],
            [ThemeColorPaletteSlots.EntityRecognitionHoverHighlight, '#3b3a39'],
            [ThemeColorPaletteSlots.TaskRecognitionUnderline, '#8a8886'],
            [ThemeColorPaletteSlots.TaskRecognitionHoverHighlight, '#3b3a39']
        );
    } else {
        propertyArray.push(
            [ThemeColorPaletteSlots.EntityRecognitionUnderline, '#484644'],
            [ThemeColorPaletteSlots.EntityRecognitionHoverHighlight, '#f3f2f1'],
            [ThemeColorPaletteSlots.TaskRecognitionUnderline, '#484644'],
            [ThemeColorPaletteSlots.TaskRecognitionHoverHighlight, '#f3f2f1']
        );
    }

    (appStylingProvider ?? (appStylingProvider = new AppStylingProvider())).setThemeProperties(
        new Map(propertyArray)
    );
}
